/**
 * @file
 * Sync the language menu urls with the current js URL.
 */

(() => {
  /* Monkey patching to respond to React history events. */
  const { pushState } = { pushState: window.history.pushState };
  window.history.pushState = function replacePushState(...args) {
    pushState.apply(window.history, args);
  };
})();
